import React from "react";
import ButtonBase from "./Buttons";

const renderField = (field, values, onFieldChange) => {
  const {
    name,
    type = "text",
    placeholder,
    min,
    max,
    options = [],
    label,
    className = "",
  } = field;

  const fieldValue = values[name] ?? "";

  return (
    <div key={name} className={`ui-filter-bar__field ${className}`.trim()}>
      {label ? <label htmlFor={name}>{label}</label> : null}

      {type === "select" ? (
        <select id={name} name={name} value={fieldValue} onChange={onFieldChange}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          value={fieldValue}
          onChange={onFieldChange}
          placeholder={placeholder}
          min={min}
          max={max}
        />
      )}
    </div>
  );
};

const FilterBar = ({
  fields,
  values,
  onFieldChange,
  onSubmit,
  onClear,
  submitLabel = "Search",
  clearLabel = "Clear",
  submitVariant = "navy",
  showClear = true,
  columns = 3,
  extraActions,
  className = "",
}) => {
  return (
    <form
      className={`ui-filter-bar ${className}`.trim()}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div
        className="ui-filter-bar__fields"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(160px, 1fr))` }}
      >
        {fields.map((field) => renderField(field, values, onFieldChange))}
      </div>

      <div className="ui-filter-bar__actions">
        <ButtonBase type="submit" variant={submitVariant} className="ui-filter-bar__action-btn">
          {submitLabel}
        </ButtonBase>

        {showClear ? (
          <ButtonBase
            type="button"
            variant="utility"
            className="ui-filter-bar__action-btn"
            onClick={onClear}
          >
            {clearLabel}
          </ButtonBase>
        ) : null}

        {extraActions}
      </div>
    </form>
  );
};

export default FilterBar;
